<template>
  <div class="mt-2">
    <!-- <h1>Packages</h1> -->
    <shop-table :products="packages" :isPackage="true" />
    <router-view name="details"></router-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import ShopTable from "../components/ShopTable.vue";

export default {
  name: "Packages",
  computed: {
    ...mapGetters(["packages"])
  },
  components: {
    ShopTable
  }
};
</script>

<style>
</style>
